import React from 'react';
import MuiTextField, { TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField';

/**
 * Pioneer TextField — wraps MUI TextField with project defaults.
 *
 * Defaults:
 * - size="small" (Pioneer standard)
 * - variant="outlined" (Pioneer standard)
 * - fullWidth={true} (Pioneer standard)
 *
 * All MUI TextField props are supported and can override defaults.
 */
export type TextFieldProps = MuiTextFieldProps;

const TextField = React.forwardRef<React.ElementRef<typeof MuiTextField>, TextFieldProps>(
  function TextField(props, ref) {
    return (
      <MuiTextField
        size="small"
        variant="outlined"
        fullWidth
        ref={ref}
        {...props}
      />
    );
  },
);

export default TextField;
